import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-redux';

import LoadingSpinner from '../components/LoadingSpinner'
import { userHasPerm } from '../utils/auth'
import { fetch } from '../utils/fetch'
import { ENDPOINT_PRESENT_TOKEN, ORCHESTRA_PLAYER_JOIN_WITH_CODE_PATH } from '../constants'

class JoinOrchestra extends Component {
  state = {};
  componentDidMount () {
    const { params, shareLogin } = this.props
    const code = params.code;
    const orch_id = params.id;
    // this.props.getToken().then(auth => {
    //   if (auth) {
    //     console.log('Token received');

    //     // open up player with token and orchestra id
    //     const redirect_url = ORCHESTRA_PLAYER_JOIN_PATH.replace(':id', orch_id) + '?token=' + auth.token;
    //     window.open(redirect_url);
    //   } else {
    //     console.log('No token returned from /present/token')
    //   }
    // })

    // just support joining with share code for now
    const redirect_url = ORCHESTRA_PLAYER_JOIN_WITH_CODE_PATH.replace(':code', code);
    this.setState({ redirect_url: redirect_url } );
    window.location = redirect_url;
  }
  render () {
    const { redirect_url } = this.state;
    return (
      <LoadingSpinner />
    );
  }
}

const mapStateToProps = ({ entities, auth, form, nav }, { params }) => ({
  entities,
  getToken: () => fetch(ENDPOINT_PRESENT_TOKEN, {
    method: 'post',
    token: auth.token
  }),
  userID: auth.user && auth.user.id,
  anonymousUser: auth.user && auth.user.id === 0,
  canShareImagesInternal: userHasPerm(auth.user, 'internal_share'),
  canShareImagesExternal: userHasPerm(auth.user, 'external_share'),
  presentTypeSelected: form.present && form.present.values && form.present.values.presentation_type,
  shouldGoBack: /\/login/.test(nav.previousPath) === false
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(JoinOrchestra)



// WEBPACK FOOTER //
// ./src/pages/JoinOrchestra.js